import { createContext, useContext } from "react";

export type SelectionTileType = "radio" | "checkbox";

type SelectionTileGroupContextValue = {
  isError: boolean;
  groupName?: string;
  groupType?: SelectionTileType;
};

export const SelectionTileGroupContext = createContext<SelectionTileGroupContextValue>({
  isError: false,
  groupName: undefined,
  groupType: undefined,
});

export const useSelectionTileGroupContext = () => useContext(SelectionTileGroupContext);
